import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./content.html";
class Content extends LightningElement {
  constructor(...args) {
    super(...args);
    this.store = {
      isLoading: false,
      isError: false,
      isEmpty: false,
      records: []
    };
    this._props = {};
  }
  set props(value) {
    this._props = value;
  }
  get props() {
    return {
      format: 'content',
      showMore: this._props._showMore,
      ...this._props
    };
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Content, {
  publicProps: {
    props: {
      config: 3
    }
  },
  track: {
    store: 1
  },
  fields: ["_props"]
});
const __lwc_component_class_internal = _registerComponent(Content, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;